import React, { useContext, useEffect, useState } from "react";
import { Checkout } from '../../styles/Layout.css'
import { Builder_, PageAlwaysVisible, PageTitle, AlertContext, Alert_, ThemeContext, Single_, Form, PageDesktopPadding, device, } from 'monica-alexandria'
import { useTranslation } from 'react-i18next'
import Summary_Shift from './components/Summary_Shift'
import styled from 'styled-components'
import Lois_Checkout from './components/Lois_Checkout';
import Payment_Details from './components/Payment_Details'
import store from "../../redux/store";
import i18n from "../../localization/i18next";
import { Elements, ElementsConsumer, LinkAuthenticationElement, PaymentMethodMessagingElement } from "@stripe/react-stripe-js";
import { calculate_tax, calculate_tax_manual } from "../../services/api/Subscriptions";
import { CartContext } from "../../context/CartContext";
import { loadStripe } from "@stripe/stripe-js";
import { Helmet } from "react-helmet";
import { retrieve_shift_price_with_vat_excluded } from "../../services/api/Plans";
 
const CheckoutGrid = styled.div`
    display: grid;
    grid-template-columns: 30rem 1fr;
    grid-gap: 4rem;
    align-items: flex-start;
 
    @media ${device.xl} {
      grid-template-columns: 1fr;
    }
`
export default function SHIFT_CHECKOUT_V3() {
 
    const { alerts, setAlerts } = useContext(AlertContext);
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK_TEST);
    const { cart } = useContext(CartContext);
    const { t } = useTranslation();
    const { theme } = useContext(ThemeContext);
    const lang = i18n.language ? i18n.language : "el";
    const currentCart = cart?.length>0 ? cart : store.getState().cart

    const customer = window.sessionStorage.getItem("customer");
    const user = store.getState().user.user;
    const coupon = window?.sessionStorage?.getItem('coupon')
    const parsedCoupon = coupon ? JSON.parse(coupon) : null;
    const trial = window?.sessionStorage?.getItem('trial')

    const [invoice, setInvoice] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedCountry, setSelectedcountry] = useState('GR')
    const showVatInput = true;
    const [selectedPrice, setSelectedPrice]= useState({})
    const query = new URLSearchParams(window.location.search);
    const isTopupRecovery = query.get('topupRecovery') === 'true';
    const topupRecovery = JSON.parse(window.sessionStorage.getItem("shiftTopupRecovery") || "null");
    const fallbackBasePrice = currentCart?.find(item => item?.property === 'base') || currentCart?.[0] || {};


    const handleStripeTheme = () => {
        let stripeTheme = theme == "dark" ? "night" : "stripe";
        return stripeTheme;
    }
    ;
    const options = isTopupRecovery ? {
        clientSecret: topupRecovery?.paymentIntentClientSecret,
        locale: lang || 'el',
        appearance: {
          theme: handleStripeTheme(),
          labels: "floating",
          variables: {
            fontSizeBase: "1.6",
            spacingUnit: "4",
            borderRadius: "1rem",
          },
        },
      } : {
        mode: "subscription",
        amount: invoice?.totalAmount || 0,
        currency: invoice?.currency || 'eur',
        // automatic_payment_methods: {enabled: true},
        paymentMethodCreation: 'manual',
        locale: lang || 'el',
        appearance: {
          theme: handleStripeTheme(),
          labels: "floating",
          variables: {
            fontSizeBase: "1.6",
            spacingUnit: "4",
            borderRadius: "1rem",
          },
        },
      };

      const buildInvoiceFromAmount = (amount, taxPercentage, currency = 'eur') => {
        const parsedAmount = parseInt(amount || 0);
        const parsedTax = Number(taxPercentage || 0);
        const taxAmount = Math.round(parsedAmount * parsedTax);
        return {
          amountWithoutTax: parsedAmount,
          taxPercentage: parsedTax,
          taxAmount: taxAmount,
          totalAmount: parsedAmount + taxAmount,
          currency: currency || 'eur',
        };
      };

      const update_cart_with_new_priceId = (taxPercentage) =>{
        retrieve_shift_price_with_vat_excluded(parsedCoupon?.couponCode)
        .then(newCart =>{
          if (!newCart?.priceId) {
            setSelectedPrice(fallbackBasePrice);
            return;
          }
          store.dispatch({ type: 'SAVE_CART', payload: [newCart] });
          setSelectedPrice(newCart);
          setInvoice(buildInvoiceFromAmount(newCart?.amount, taxPercentage, newCart?.currency || fallbackBasePrice?.currency || 'eur'));
        })
      }
 
      const calculate_invoice_amount = () => {
        calculate_tax_manual(selectedCountry, parsedCoupon?.couponId, fallbackBasePrice?.amount, showVatInput)
            .then(res => {
                console.log("res tax", res);
                const taxPercentage = res?.taxCalculation?.taxPercentage;
                if(res?.taxCalculation?.taxPercentage === 0.24) {
                  update_cart_with_new_priceId(taxPercentage);
                }
                else {
                  setSelectedPrice(fallbackBasePrice);
                  setInvoice(buildInvoiceFromAmount(fallbackBasePrice?.amount, taxPercentage, fallbackBasePrice?.currency || 'eur'));
                }

                setIsLoading(false);
            })
            .catch(err => {
                console.log('ERROR',err);
                setIsLoading(false);
            });
    };
 
      useEffect(()=>{
        if (isTopupRecovery) {
          setIsLoading(false);
          return;
        }
        if(currentCart?.length > 0 && selectedCountry) {
          calculate_invoice_amount()
        }
      },[currentCart, coupon, selectedCountry, showVatInput, isTopupRecovery])

      console.log('customer', customer)
      console.log('invoice', invoice)
      console.log("selectedCountry", selectedCountry)
      console.log("selectedPrice", selectedPrice)
      console.log("showVatInput", showVatInput)
      console.log('currentCart', currentCart)

    if(isLoading && selectedPrice){ return(
        <Single_
         backgroundImage="https://genius1071.friktoriaservers.net/doitforme/morning/app/griphook/ToStripe.svg"
         title={t("Checkout")}
         subtitle={t("Redirecting you to Stripe")}
         text={t("Hold on tight, while we teleport you to the magical land of Stripe where payments are as smooth as butter and the unicorns roam free!")}
       />
    );
    } 
    else return (
        <Checkout>
        <Helmet>
          <title>Doitforme | Shift subscribe</title>
        </Helmet>
        <Alert_ messages={alerts} duration={5000}/>
            <PageAlwaysVisible>
                <PageTitle>
                    <h1>{t("Checkout")}</h1>
                </PageTitle>
                <CheckoutGrid>
                    <Lois_Checkout />
                    <Summary_Shift
                      trial={isTopupRecovery ? false : trial==='true' ? true : false}
                      discount={isTopupRecovery ? {} : parsedCoupon}
                      amount={isTopupRecovery ? (topupRecovery?.invoiceAmountDue || 0) : (selectedPrice?.amount || fallbackBasePrice?.amount)}
                      tax={isTopupRecovery ? 0 : invoice?.taxAmount}
                      total={isTopupRecovery ? (topupRecovery?.invoiceAmountDue || 0) : invoice?.totalAmount}
                      currency={isTopupRecovery ? (topupRecovery?.invoiceCurrency || 'eur') : invoice?.currency || '€'}
                    />
                </CheckoutGrid>
            </PageAlwaysVisible>
            <PageAlwaysVisible>
              <PageDesktopPadding>
                {options &&  
                  <Form>
                    <Elements stripe={stripePromise} options={options}>
                      <h3>{isTopupRecovery ? t("Payment details") : t("Billing information")}</h3>
                      <Payment_Details selectedPrice={selectedPrice} discount={isTopupRecovery ? null : parsedCoupon?.couponId} selectedCountry={selectedCountry} setSelectedCountry={setSelectedcountry} setShowVatInput={() => {}} showVatInput={showVatInput} trial={isTopupRecovery ? false : trial==='true' ? true : false} total={isTopupRecovery ? (topupRecovery?.invoiceAmountDue || 0) : invoice?.totalAmount} currency={isTopupRecovery ? (topupRecovery?.invoiceCurrency || 'eur') : invoice?.currency || '€'} isTopupRecovery={isTopupRecovery} topupRecovery={topupRecovery}/>
                    </Elements> 
                  </Form>
                  }
                </PageDesktopPadding>
            </PageAlwaysVisible>
        </Checkout>
  )
}
